import {
    IFilterValueMap,
    IFolderBase,
    IOrganizationUnit,
    RobotTypeAttended,
} from '@models';

export enum UserType {
    User,
    Robot,
    DirectoryUser,
    DirectoryGroup,
}

export enum ADResultType {
    User,
    Group,
}

export interface IUserProfile {
    name: string;
    surname: string;
    emailAddress: string;
    tenantDisplayName: string;
    userName: string;
    notificationSettings?: INotificationSettings;
}

export interface IRobotProvision {
    isExternalLicensed?: boolean;
    userName?: string;
    executionSettings?: Record<string, any>;
    type: RobotTypeAttended | null;
}

export interface IUser extends IUserProfile {
    id: number;
    domain: string;
    fullName: string;
    isEmailConfirmed: boolean;
    isActive: boolean;
    authenticationSource: string;
    password: string;
    lastLoginDate?: Date;
    creationTime: Date;
    rolesList: Array<string>;
    hasRole?: boolean;
    tenancyName: string;
    tenancyId: number;
    type: UserType;
    organizationUnits: Array<IOrganizationUnit>;
    hasOrganization?: boolean;
    notificationSettings: INotificationSettings;
    mayHaveUserSession: boolean;
    mayHaveRobotSession: boolean;
    licenseType?: RobotTypeAttended | null;
    robotProvision?: IRobotProvision;
    isExternalLicensed?: boolean;
    bypassBasicAuthRestriction: boolean;
}

export interface INotificationSettings {
    transactions: boolean;
    robots: boolean;
    jobs: boolean;
    tasks: boolean;
    schedules: boolean;
    queues: boolean;
}

export interface IUserLoginInfo {
    id: number;
    userName: string;
    name: string;
    surname: string;
    emailAddress: string;
}

export interface LoginPayload {
    tenancyName?: string;
    usernameOrEmailAddress: string;
    password: string;
    rememberMe: boolean;
}

export interface IRoleSource {
    id: number;
    username: string;
    isInherited: boolean;
}

export interface IUserRole {
    id: number;
    name: string;
    source: IRoleSource[];
}

export interface IFolderRole {
    id: number;
    folder: IFolderBase;
    roles: IUserRole[];
}

export interface IUserRoles {
    tenantRoles: IUserRole[];
    folderRoles: IFolderRole[];
    count: number;
}

export const USER_ICON_MAP: Record<UserType, { matIcon?: string; 'svgIcon'?: string; }> = {
    [UserType.User]: { matIcon: 'person' },
    [UserType.Robot]: { svgIcon: 'uipath:robots' },
    [UserType.DirectoryUser]: { svgIcon: 'uipath:ad-user' },
    [UserType.DirectoryGroup]: { matIcon: 'group' },
};

export const AD_TO_USER_MAP = {
    [ADResultType.User]: UserType.DirectoryUser,
    [ADResultType.Group]: UserType.DirectoryGroup,
};


export enum UserRobotAccess {
    Disabled,
    Enabled,
    Group,
}

export const USER_ROBOT_ACCESS_FILTER: IFilterValueMap<typeof UserRobotAccess, IUser> = {
    Disabled: [{
        property: 'mayHaveRobotSession',
        method: 'eq',
        value: false,
    }],

    Group: [{
        property: 'mayHaveRobotSession',
        method: 'eq',
        value: true,
    }, {
        property: 'licenseType',
        method: 'eq',
        value: null,
    }, {
        property: 'type',
        method: 'eq',
        value: UserType[UserType.DirectoryUser],
    }],

    Enabled: [{
        property: 'mayHaveRobotSession',
        method: 'eq',
        value: true,
    }, {
        property: 'licenseType',
        method: 'ne',
        value: null,
    }],
};
